module.exports = __webpack_public_path__ + "static/media/orgchart_off.d8aa43c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/orgchart_off.jpg
// module id = 737
// module chunks = 0